import { createAction } from 'redux-actions';
export const SET_PRICE = 'SET_PRICE';
export var PriceBreakdownType;
(function (PriceBreakdownType) {
    PriceBreakdownType["Total"] = "Order";
    PriceBreakdownType["Service"] = "Service";
    PriceBreakdownType["Upsale"] = "Upsale";
})(PriceBreakdownType || (PriceBreakdownType = {}));
export const setBreakdownPrices = createAction(SET_PRICE, (priceBreakdown) => priceBreakdown);
